// src/components/CopySuccessPopup.jsx
import { useEffect, useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi'; // Import FiCheckCircle

import './CopySuccessPopup.css'; // Import CSS for styling

const CopySuccessPopup = ({ message, isOpen, onClose }) => {

  // Auto-close after 3 seconds
  useEffect(() => {
    if (isOpen) {
      // console.log('Popup timer started');
      const timer = setTimeout(() => {
        clearTimeout(timer);

        onClose();
      }, 2000);

    }
  }, [isOpen, onClose]);


  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <FiCheckCircle className="checkmark" />
        <p>{message}</p>
      </div>
    </div>
  );
};

export default CopySuccessPopup;